/**
 * keep-focus — 다시 그리는 동안 입력 칸의 포커스 · 커서를 지킨다(2026-10-28).
 * 목록 페이지는 도구 줄(찾기 칸)이 다시 그리는 구역 안에 있어, 자동 검색 결과로 구역을 다시 그리면 치던 칸이 새로 그려져 포커스가 빠졌다.
 * 그리기 전 포커스된 칸(data-action, 줄마다 있는 칸이면 data-id 까지)과 커서를 기억하고, 다시 그린 구역의 같은 칸에 되돌린다.
 * 칸이 없어졌으면(탭이 바뀜) 그냥 둔다.
 */

const TEXT_INPUT_TYPES: readonly string[] = ['text', 'search'];   // 커서(selectionStart)가 있는 칸 — date · checkbox 엔 없다

/** refresh 로 regionSelector 구역을 다시 그리되, 그 안에서 치던 칸의 포커스 · 커서를 되돌린다 */
export function refreshKeepingFocus(root: HTMLElement | null, regionSelector: string, refresh: () => void): void {
  const active = document.activeElement;
  const bTyping = root !== null && active instanceof HTMLInputElement && active.dataset.action !== undefined && root.contains(active);
  const action = bTyping ? active.dataset.action : undefined;
  const idFilter = bTyping && active.dataset.id !== undefined ? `[data-id="${active.dataset.id}"]` : '';   // 줄마다 같은 칸(안전재고 칸)이면 그 줄로
  const caret = bTyping && TEXT_INPUT_TYPES.includes(active.type) ? active.selectionStart : null;
  refresh();
  if (root === null || action === undefined) return;
  const input = root.querySelector<HTMLInputElement>(`${regionSelector} input[data-action="${action}"]${idFilter}`);
  if (input === null) return;
  input.focus();
  if (caret !== null) input.setSelectionRange(caret, caret);
}
